import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from 'components/InputField';
import FormError from 'components/FormError';

const UpdateSimoDeviceForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <Field component={InputField} name="serial_number" label="Device SN" />
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Update Device</button>
  </form>
);

const validate = (values) => {
  let errors = {};

  if (!values.serial_number) {
    errors.serial_number = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'simoDevice',
  validate,
  enableReinitialize: true,
})(UpdateSimoDeviceForm);
